module.exports = __webpack_public_path__ + "img/es.acc0f67a.png";